module.exports = "<div class=\"header\">\n  <h1><a href=\".\"><</a> Link</h1>\n</div>\n<iframe src=\"apps/link/index.html\"></iframe>\n"


//////////////////
// WEBPACK FOOTER
// /home/manu/ArtCode/artCode/artCode/src/app/pages/link/link.component.html
// module id = ../../../../../src/app/pages/link/link.component.html
// module chunks = main